"use strict";

require("core-js/modules/es6.object.assign");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var react_dom_1 = require("react-dom");

var use_ssr_1 = __importDefault(require("use-ssr"));

function usePortal(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
      closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? true : _ref$closeOnOutsideCl,
      _ref$closeOnEsc = _ref.closeOnEsc,
      closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
      renderOnClickedElement = _ref.renderOnClickedElement,
      renderBelowClickedElement = _ref.renderBelowClickedElement,
      bindTo = _ref.bindTo,
      _ref$isOpen = _ref.isOpen,
      defaultIsOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$stateful = _ref.stateful,
      stateful = _ref$stateful === void 0 ? true : _ref$stateful;

  var _use_ssr_1$default = use_ssr_1.default(),
      isServer = _use_ssr_1$default.isServer,
      isBrowser = _use_ssr_1$default.isBrowser;

  var _react_1$useState = react_1.useState(defaultIsOpen),
      isOpen = _react_1$useState[0],
      makeOpen = _react_1$useState[1]; // we use this ref because `isOpen` is stale for handleOutsideMouseClick


  var open = react_1.useRef(isOpen);
  var setOpen = react_1.useCallback(function (v) {
    // workaround to not have stale `isOpen` in the handleOutsideMouseClick
    open.current = v;
    makeOpen(v);
  }, [isOpen, open.current]);
  var renderByRef = react_1.useRef();
  var portal = react_1.useRef(isBrowser && document.createElement('div'));
  react_1.useEffect(function () {
    if (isBrowser && !portal.current) portal.current = document.createElement('div');
  }, [isBrowser]);
  var elToMountTo = react_1.useMemo(function () {
    if (isServer) return;
    return bindTo && react_dom_1.findDOMNode(bindTo) || document.body;
  }, [isServer, bindTo]);
  var handleKeydown = react_1.useCallback(function (e) {
    var ESC = 27;
    if (e.keyCode === ESC && stateful && closeOnEsc) setOpen(false);
  }, [closeOnEsc, stateful, setOpen]);
  var openPortal = react_1.useCallback(function (e) {
    if (isServer) return; // for some reason, when we don't have the event argument there
    // is a weird race condition, would like to see if we can remove
    // setTimeout, but for now this works

    if (e == null) return setTimeout(function () {
      return stateful && setOpen(true);
    }, 0);
    if (e && e.nativeEvent) e.nativeEvent.stopImmediatePropagation();

    var _e$target$getBounding = e.target.getBoundingClientRect(),
        left = _e$target$getBounding.left,
        top = _e$target$getBounding.top,
        height = _e$target$getBounding.height;

    if (renderOnClickedElement && portal.current instanceof HTMLElement) {
      portal.current.style.height = '0px';
      portal.current.style.position = 'absolute';
      portal.current.style.left = left + 'px';
      portal.current.style.top = top + 'px';
    } else if (renderBelowClickedElement && portal.current instanceof HTMLElement) {
      portal.current.style.position = 'absolute';
      portal.current.style.left = left + 'px';
      portal.current.style.top = top + height + 'px';
    }

    stateful && setOpen(true);
  }, [isServer, stateful, portal, setOpen, renderBelowClickedElement, renderOnClickedElement]);
  var closePortal = react_1.useCallback(function () {
    if (isServer) return;
    if (open.current) setOpen(false);
  }, [isServer, isOpen, open.current, setOpen]);
  var togglePortal = react_1.useCallback(function (e) {
    return isOpen ? setOpen(false) : openPortal(e);
  }, [isOpen, open.current, setOpen, openPortal]);
  var handleOutsideMouseClick = react_1.useCallback(function (_ref2) {
    var target = _ref2.target,
        button = _ref2.button;
    if (isServer || !(portal.current instanceof HTMLElement)) return;
    if (portal.current.contains(target) || button !== 0 || !open.current) return;
    if (stateful && closeOnOutsideClick) closePortal();
  }, [isServer, isOpen, stateful, closePortal, closeOnOutsideClick]);
  react_1.useEffect(function () {
    if (isServer || !(elToMountTo instanceof HTMLElement) || !(portal.current instanceof HTMLElement)) return;
    var node = portal.current;
    elToMountTo.appendChild(portal.current);
    document && document.addEventListener('keydown', handleKeydown);
    document && document.addEventListener('click', handleOutsideMouseClick);
    return function () {
      document && document.removeEventListener('keydown', handleKeydown);
      document && document.removeEventListener('click', handleOutsideMouseClick);
      elToMountTo.removeChild(node);
    };
  }, [isServer, handleOutsideMouseClick, handleKeydown, elToMountTo]);
  var Portal = react_1.useCallback(function (_ref3) {
    var children = _ref3.children;
    if (portal.current instanceof HTMLElement) return react_dom_1.createPortal(children, portal.current);
    return null;
  }, []);
  return Object.assign([openPortal, closePortal, open.current, Portal, togglePortal], {
    isOpen: open.current,
    openPortal: openPortal,
    onMouseDown: handleKeydown,
    ref: renderByRef,
    closePortal: closePortal,
    togglePortal: togglePortal,
    Portal: Portal,
    bind: {
      onMouseDown: handleKeydown,
      ref: renderByRef
    }
  });
}

exports.default = usePortal;